/**
 *
 * @param ruleData
 * @param abilityLookup
 * @param proficiencyBonus
 */
export function hack__generatePdfDataBucket1AndBucket2Parts(ruleData, abilityLookup, proficiencyBonus) {
    return {
        ruleData,
        abilityLookup,
        proficiencyBonus,
    };
}
